const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

// TODO: DRY pop-up configuration
const SUCCESS_URL = 'https://aw.bff.fm/html/donation-success.html';
const WINDOW_WIDTH = 780;
const CORE_POPUP_OPTIONS = [
  'resizable',
  'width=' + WINDOW_WIDTH,
  'height=640',
  'alwaysRaised'
];

// Any link to a Kindful widget URL will inject it into a pop-up rather than new window
const HIJACK_URL_REGEX = /^https?:\/\/bestff.kindful.com\/widget/;
const AMOUNT_REGEX = /\[amount\]=(\d+)/;

const KindfulLinkHandler = forgeUiComponent('KindfulLinkHandler', {}, function KindfulLinkHandlerConstructor() {
  const self = this;

  document.addEventListener('click', function (e) {
    const linkTarget = e.target && e.target.closest && e.target.closest('A');

    // Some other component cancelled the event
    if (e.defaultPrevented) { return; }

    // If there's no link target, ignore:
    if (!linkTarget) { return; }

    // If the link points to a different domain, ignore:
    if (!HIJACK_URL_REGEX.test(linkTarget.href)) { return; }

    // If the user is holding down a modifier key for new tab/download behaviour, ignore:
    if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) { return; }

    if (AMOUNT_REGEX.test(linkTarget.href)) {
      const donationAmount = RegExp.$1;
      linkTarget.dispatchEvent(new CustomEvent(events.donationStarted, {
        bubbles: true,
        detail: {
          amount: donationAmount
        }
      }));
    }

    const popupUrl = self.buildPopupUrl(linkTarget.href);
    self.popupKindful(popupUrl);

    e.preventDefault();
  }, false);
});

KindfulLinkHandler.prototype.buildPopupUrl = function makePopupUrl(baseWidgetUrl) {
  var params = {};

  if (baseWidgetUrl.indexOf('cart[desc]') === -1) {
    params['cart[desc]'] = 'Donation to BFF.fm';
  }

  params.success_url = SUCCESS_URL;
  params.success_action = 'GET';

  const serializedParams = Object.keys(params).map(function (k) {
    return [k, encodeURIComponent(params[k])].join('=');
  }).join('&');

  // HACK: These URLs should already contain params so we just append to the end
  return [baseWidgetUrl, serializedParams].join('&');
};

KindfulLinkHandler.prototype.popupKindful = function popupKindfulFlow(url) {
  const posX = ((window.outerWidth / 2) + window.screenX) - Math.floor(WINDOW_WIDTH / 2);
  const posY = window.screenY + 40;

  const finalFeatures = CORE_POPUP_OPTIONS.concat([
    'left=' + posX,
    'top=' + posY
  ]).join(',');

  window.open(url, '_blank', finalFeatures);
};

// Unlike other UIComponents, Twitter widgets are initialized within the element root,
// so we always return one component that may or may not contain widgets later.
//
// TODO: DRY: Make this a `Discoverable` mix-in
KindfulLinkHandler.discover = function (root) {
  return {
    components: [new KindfulLinkHandler(root)],
    errors: []
  };
};

module.exports = KindfulLinkHandler;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/kindful-link-handler.js
// module id = 66
// module chunks = 0